import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SideBar from '../components/SideBar';
import styled from 'styled-components';
import { Share, PlayMusic } from '../../../ui/icons';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import CourseInfo from './CourseInfo';
import Teachers from './Teachers';
import Training from './Training';


const WtSide = styled.div`
    display: flex;
    gap: clamp(10px, 2vw, 20px);
    flex-wrap: wrap;
`;

const Card = styled.div`
    display: flex;
    flex-direction:column;
    gap:16px;
    width: 24%;
`;

const Images = styled.div`
    @media(max-width: 1032px) {
        flex-direction:column;
    }
`;

const VideoContainer = styled.div`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    background-color: #000;
    cursor: pointer;
    margin-bottom: 20px;
`;

const VideoThumbnail = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('./images/AboutCourse/courseimg.png');
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const VideoPlayer = styled.video`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const First = () => {
    const { t } = useTranslation();
    const [showVideo, setShowVideo] = useState(false);
    const { mainVideo } = useSelector((state) => state.courses);

    const cards = [
        {
            title: t('course.0.books.book1.title'),
            img: './images/AboutCourse/Card.png',
            location: t('course.0.books.book1.author'),
            link: "#"
        },
        {
            title: t('course.0.books.book2.title'),
            img: './images/AboutCourse/Card2.png',
            location: t('course.0.books.book2.author'),
            link: "#"
        },
        {
            title: t('course.0.books.book3.title'),
            img: './images/AboutCourse/Card4.png',
            location: t('course.0.books.book3.author'),
            link: "#"
        },
        {
            title: t('course.0.books.book4.title'),
            img: 'https://m.media-amazon.com/images/I/41gBxCM5HDL._SY425_.jpg',
            location: t('course.0.books.book4.author'),
            link: "#"
        },
    ];

    return (
        <section className='px-4 sm:px-6 py-16'>
            <div className='flex items-center justify-between'>
                <h2 className='text-[30px] font-medium'>{t('course.0.about.title')}</h2>
                <Share />
            </div>
            <WtSide className='pt-5'>
                <Images className='flex justify-between'>
                    <div className='w-full sm:w-2/3'>
                        <VideoContainer onClick={() => setShowVideo(true)}>
                            {showVideo ? (
                                <VideoPlayer 
                                    autoPlay 
                                    controls
                                    src={mainVideo.introductory_video}
                                >
                                    {t('video_not_supported')}
                                </VideoPlayer>
                            ) : (
                                <VideoThumbnail>
                                    <PlayMusic />
                                </VideoThumbnail>
                            )}
                        </VideoContainer>
                    </div>
                    <SideBar />
                </Images>
                <div className='flex flex-col gap-2 w-full sm:w-2/3'>
                    <div className='flex flex-col'>
                        <h3 className='text-[#0A1F44] text-[24px] font-semibold mt-5'>
                            {t('course.0.reading.title')}
                        </h3>
                        <p className='text-[#5C5C5C] pb-2 pt-4'>
                            {t('course.0.reading.recommendation')}
                        </p>
                        <div className='flex'>
                            <Swiper
                                slidesPerView={4}
                                spaceBetween={5}
                                modules={[Pagination]}
                                breakpoints={{
                                    0: { slidesPerView: 2 },
                                    768: { slidesPerView: 4 }
                                }}
                            >
                                {cards.map((card, index) => (
                                    <SwiperSlide key={index} className='cursor-pointer'>
                                        <p className="pr-4">
                                            <img src={card.img} alt={card.title} className="w-full" />
                                            <h4 className="font-semibold mt-2">{card.title}</h4>
                                            <p className="text-[#1E1E1E] opacity-80 pt-1 text-[16px]">{card.location}</p>
                                        </p>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>

                    <CourseInfo />
                </div>
                <Teachers />
                <Training />
            </WtSide>
        </section>
    );
};

export default First;